import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../service/helper/reduxHelper';
import { IRawClockTransaction } from '../../@types/model/rawClock/rawClockTransaction/rawClockTransaction';

export default class RawClockActions {
    public static setIsLoading = createAction('RAW_CLOCK_SET_LOADING', withPayloadType<boolean>());
    public static setRawClockTransactionData = createAction('RAW_CLOCK_TRANSACTION_SET_LIST', withPayloadType<Array<IRawClockTransaction> | null>());
}
